/**
 * Human-friendly labels for asset_type enum values.
 *
 * Backend stores raw enums ('bond', 'equity', 'etf', etc). The UI
 * should display investor-relevant names — 'bond' → 'Fixed Income',
 * 'equity' → 'Equities', etc. Unknown values are title-cased.
 */

const LABELS: Record<string, string> = {
  bond: 'Fixed Income',
  equity: 'Equities',
  etf: 'ETFs',
  fund: 'Funds',
  stock: 'Equities',
  crypto: 'Crypto',
  cash: 'Cash',
  real_estate: 'Property',
  liability: 'Liabilities',
}

export function labelAssetType(asset_type: string | null | undefined): string {
  if (!asset_type) return ''
  const key = asset_type.toLowerCase()
  if (LABELS[key]) return LABELS[key]
  return key.charAt(0).toUpperCase() + key.slice(1)
}

/**
 * For per-holding bond refinement: when the holding has sector info,
 * return a specific label ('UK Gilts', 'Corporate Bonds', etc), else
 * fall back to the generic 'Fixed Income'.
 */
export function labelBondSector(sector: string | null | undefined): string {
  if (!sector) return 'Fixed Income'
  const s = sector.toLowerCase()
  if (s.includes('gilt') || s.includes('government')) return 'Gilts'
  if (s.includes('corporate')) return 'Corporate Bonds'
  if (s.includes('high yield') || s.includes('junk')) return 'High-Yield Bonds'
  if (s.includes('index-linked') || s.includes('linker')) return 'Index-Linked Gilts'
  if (s.includes('em ') || s.includes('emerging')) return 'EM Bonds'
  return 'Fixed Income'
}
